export default "__VITE_ASSET__BHFRvu6d__"